export default "__VITE_PUBLIC_ASSET__32119500__"